import React, { useCallback, useEffect, useRef } from 'react'
import { ModalBody, ModalCloseButton, ModalHeader, ModalMain, ModalMainContainer, ModalTitle, ModalWrapper } from './index.styled'
import MainIcon from '../../../../img/svg/main'
import Portal from '../../Portal'
import { useDispatch } from 'react-redux'
import { setAppEventZIndex } from '../../../../redux/action/system'

const CustomRightModal = React.memo(({
	isOpen = false, close, title,
	children, id, zIndex, returnZIndex = 0, enableOutsideClick = true, className
}) => {
	const modalMainRef = useRef()
	const layout = (isOpen ? 'active ' : '') + className
	const bodyLayout = className
	const dispatch = useDispatch()

	useEffect(() => {
		if (isOpen) {
			dispatch(setAppEventZIndex(zIndex))
		}
		return () => {
			dispatch(setAppEventZIndex(returnZIndex))
		}
	}, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

	const handleModalWrapperMouseDown = useCallback(() => {
		if (enableOutsideClick) {
			close()
		}
	}, [enableOutsideClick, close])

	const handleModalMainMouseDown = useCallback(e => {
		e.stopPropagation()
	}, [])

	return (
		<Portal containerId="content">
			<ModalWrapper id={id}
										data-testid={id}
										onMouseDown={handleModalWrapperMouseDown}
										className={layout}
										zIndex={zIndex}>
				<ModalMainContainer className={layout}>
					<ModalMain onMouseDown={handleModalMainMouseDown}
										 className={layout}
										 ref={modalMainRef}>
						<ModalHeader className={layout} zIndex={zIndex}>
							<ModalTitle className={layout}>{title}</ModalTitle>
							<ModalCloseButton data-testid="close-button" onClick={close} className={layout}>
								<MainIcon icon="white-cross" />
							</ModalCloseButton>
						</ModalHeader>
						<ModalBody className={bodyLayout}>
							{isOpen && children}
						</ModalBody>
					</ModalMain>
				</ModalMainContainer>
			</ModalWrapper>
		</Portal>
	)
})

CustomRightModal.displayName = 'CustomRightModal'
export default CustomRightModal
